<template>
  <md-card>
    <input v-model="vehicle.id" :readonly="true" type="hidden"/>
    <md-card-content>
      <div style="margin-bottom:20px;" class="md-layout-item md-size-50 md-small-size-100">
          <validation-provider rules="require" ref="vehicle_km" v-slot="{ errors }">
          <md-field class="md-invalid">
            <label for="">Vehicle KM</label>
            <md-input v-model="vehicle.vehicle_km" type="text" v-on:keypress="NumbersOnly" required/>
            <validation-error :errors="apiValidationErrors.vehicle_km" />
          <span class="md-error">{{ errors[0] }}</span>
          </md-field>
          </validation-provider>
        </div>
      <!-- <md-button class="md-icon-text md-round md-primary" v-on:click="findVehicle()">Find Vehicle</md-button> -->
      <div class="md-layout">
        <div v-if="service_estimate.service_estimate_type != 2" class="md-layout-item md-size-50 md-small-size-100">
           <div class="md-layout">
               <div class="md-layout-item md-size-50 md-small-size-60">
                 
                  <!-- <validation-provider rules="doorno" ref="vehicle_door_no" v-slot="{ errors }"> -->
                  <md-field class="md-invalid">
                    <label for="">Vehicle No</label>
                    <md-input v-model="vehicle.vehicle_door_no"  />
                    <validation-error :errors="apiValidationErrors.vehicle_door_no" />
                  <!-- <span class="md-error">{{ errors[0] }}</span> -->
                  </md-field>
                  <!-- </validation-provider> -->
               </div>
                <div class="md-layout-item md-size-50 md-small-size-40">
                  <md-button :disabled="!vehicle.vehicle_door_no" class="md-icon-text md-round md-primary" v-on:click="findVehicleDoorNo()">Find Vehicle</md-button>
                </div>
           </div>
        </div>
        <div v-if="service_estimate.service_estimate_type == 2"  class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Customer Name</label>
            <md-input v-model="vehicle_external_name" disabled/>
          </md-field>
        </div>

        <div v-if="service_estimate.service_estimate_type == 2"  class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Customer Phone</label>
            <md-input v-model="vehicle_external_phone" disabled/>
            <validation-error :errors="apiValidationErrors.vehicle_external_phone" />
          </md-field>
        </div>

        <div v-if="service_estimate.service_estimate_type == 2"  class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Customer Email</label>
            <md-input v-model="vehicle_external_email" disabled/>
          </md-field>
        </div>

        <div v-if="service_estimate.service_estimate_type == 2"  class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Customer Address</label>
            <md-input v-model="vehicle_external_address" disabled/>
          </md-field>
        </div>
        <div v-if="service_estimate.service_estimate_type == 2"  class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Production Year</label>
            <md-input v-model="vehicle.vehicle_production_year" :key="vehicle_production_year" disabled/>
          </md-field>
        </div>

       
        

      <!-- </div>
        
      <div class="md-layout"> -->
        <div class="md-layout-item  md-size-50 md-small-size-100">
           <div class="md-layout">
               <div class="md-layout-item md-size-50 md-small-size-60">
                  
                  <validation-provider
                    rules="require"
                    ref="vehicle_plate_no"
                    v-slot="{ errors }"
                  >
                    <md-field class="md-invalid">
                      <label for="">Plate No</label>
                      <md-input required v-model="vehicle.vehicle_plate_no"/>
                      <validation-error
                        :errors="apiValidationErrors.vehicle_plate_no"
                      />
                    <span class="md-error">{{ errors[0] }}</span>
                    </md-field>
                  </validation-provider>
               </div>
               <div class="md-layout-item md-size-50 md-small-size-40">
                  <md-button :disabled="!vehicle.vehicle_plate_no" class="md-icon-text md-round md-primary" v-on:click="findVehiclePlatNo()">Find Vehicle</md-button>
               </div>
           </div>
        </div>

        <div v-if="service_estimate.service_estimate_type != 2" class="md-layout-item  md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Plate Color</label>
            <md-input v-model="vehicle.vehicle_plate_color" required disabled/>
          </md-field>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <div v-if="service_estimate.service_estimate_type != 2" class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label>Pool</label>
            <md-input  v-model="vehicle.vehicle_pool" required disabled/>
          </md-field>
        </div>

        <div v-if="service_estimate.service_estimate_type != 2" class="md-layout-item  md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label>Registration Year</label>
            <md-input type="year" v-model="vehicle.vehicle_registration_year" disabled />
          </md-field>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <!-- <div v-if="service_estimate.service_estimate_type != 2" class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Business Unit</label>
            <md-input required v-model="vehicle.vehicle_business_unit"  disabled />
          </md-field>
        </div> -->

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label>Registration Name</label>
            <md-input type="year" v-model="vehicle.vehicle_registration_name" :key="vehicle_registration_name" disabled/>
          </md-field>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label>Vehicle Type</label>
            <md-input v-model="vehicle.vehicle_type"  :key="vehicle_type" disabled/>
          </md-field>
        </div>
        <div class="md-layout-item md-size-50 md-small-size-100">
            <md-field class="md-invalid">
              <label>Engine No</label>
              <md-input v-model="vehicle.vehicle_engine_no" :key="vehicle_engine_no" disabled/>
            </md-field>
        </div>
      <!-- </div>

      <div class="md-layout"> -->
        
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Body Color</label>
            <md-input v-model="vehicle.vehicle_body_color" :key="vehicle_body_color" disabled/>
          </md-field>
        </div>
        
        
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-field class="md-invalid">
            <label for="">Chassis No</label>
            <md-input v-model="vehicle.vehicle_chassis_no" :key="vehicle_chassis_no" disabled/>
          </md-field>
        </div>
        


    </div>
    </md-card-content> 
    <modal ref="modalList">
      <template v-slot:header>
        <div>
          <h3>List Vehicle Type</h3>
        </div>
        <md-button class="md-dense md-round md-icon-button" @click="CloseListVehicleType()"><md-icon>close</md-icon></md-button>
      </template>
      
      <template v-slot:body>
        <list-vehicle  :data_id="$refs.modalList.data"/>
      </template>
    </modal>
    <modal ref="modalAddVehicleExternalPage" class="coba">
      <template v-slot:header>
        <div style="text-align:center; margin:auto;">
        <h5 >ADD VEHICLE EXTERNAL</h5>
        </div>
        <md-button class="md-icon-button md-dense md-round"  @click="modalCloseAddVehicleExternal()">
          <md-icon >close</md-icon>
        </md-button>
      </template>
      <template v-slot:body >
        <add-vehicle-external :data_id="$refs.modalAddVehicleExternalPage.data" />
      </template>
    </modal>
  </md-card> 
         
</template>
<script>
import { ValidationError,Modal } from "@/components";
import formMixin from "@/mixins/form-mixin";
import findVehiceCard from "@/pages/Dashboard/Workshop/ServiceEstimate/ComponentForm/modal/ListVehicleType.vue";
// import addVehicleExternal from "@/pages/Dashboard/Workshop/VehicleEksternal/AddVEPage.vue";
import {extend} from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import Swal from "sweetalert2";


extend('require', {
  ...required,
  message: 'Field is required'
  });
extend('vehiclekm', {
  ...required,
  message: 'Vehicle KM is required'
  });
  
extend('vehicletype', {
  ...required,
  message: 'Field is required'
  });
extend('custname', {
  ...required,
  message: 'Name field is required'
  });
extend('custphone', {
  ...required,
  message: 'Phone field is required'
  });
extend('custemail', {
  ...required,
  message: 'Email field is required'
  });

export default {
  name: "vehicle-card",

  props: 
    ['service_estimate']
  ,

  components: { ValidationError, Modal ,
    //  "list-vehicle": findVehiceCard,
    //   "add-vehicle-external": addVehicleExternal
     },

  mixins: [formMixin],
  data() {
    return {
      vehicle: [],
      dataValid: false,
      vehicle_external_address: null,
      vehicle_external_email: null,
      vehicle_external_phone: null,
      vehicle_external_name: null,
      vehicle_engine_no: null,
      vehicle_production_year: null,
      vehicle_plate_no: null,
      vehicle_registration_name: null,
      vehicle_body_color: null,
      vehicle_chassis_no: null,
      vehicle_type: null,
    };
  },

  methods: {
   getDataParent(){
        console.log(this.service_estimate)
        if(this.service_estimate.service_estimate_vehicle){
          this.setData(this.service_estimate.service_estimate_vehicle)
        }
        this.vehicle.vehicle_km = this.service_estimate.service_estimate_vehicle_km
        },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getData() {
        this.$emit('data', this.vehicle)
       
    },

    async findVehicle(){
      this.$refs.modalList.openModal()
    },

    setData(data){
      console.log(data);
      if(this.vehicle.vehicle_km){
        data.vehicle_km = this.vehicle.vehicle_km
      }
      if(this.service_estimate.service_estimate_type == 1){
        this.vehicle = data
        if(data.vehicle_body_color == 0){
          this.vehicle.vehicle_body_color = "Putih"
        }
        else if(data.vehicle_body_color == 1){
          this.vehicle.vehicle_body_color = "Putih Kuning"
        }
        else if(data.vehicle_body_color == 2){
          this.vehicle.vehicle_body_color = "Putih Metalik"
        }
        else if(data.vehicle_body_color == 3){
          this.vehicle.vehicle_body_color = "Hitam"
        }
        else if(data.vehicle_body_color == 4){
          this.vehicle.vehicle_body_color = "Hitam Metalik"
        }
        else if(data.vehicle_body_color == 5){
          this.vehicle.vehicle_body_color = "Silver"
        }
        else if(data.vehicle_body_color == 6){
          this.vehicle.vehicle_body_color = "Silver Metalik"
        }
        else if(data.vehicle_body_color == 7){
          this.vehicle.vehicle_body_color = "Abu Abu"
        }
        else if(data.vehicle_body_color == 8){
          this.vehicle.vehicle_body_color = "Abu Abu Metalik"
        }
        else if(data.vehicle_body_color == 9){
          this.vehicle.vehicle_body_color = "N/A"
        }
        if(data.vehicle_plate_color == 0){
          this.vehicle.vehicle_plate_color = "Kuning"
        }
        else if(data.vehicle_plate_color == 1){
          this.vehicle.vehicle_plate_color = "Hitam"
        }
       
          this.vehicle.vehicle_pool = data.vehicle_pool ? data.vehicle_pool.pool_name : ""
        
        // this.vehicle.vehicle_business_unit = this.vehicle.vehicle_business_unit.business_unit_name
        if(this.vehicle.vehicle_type){
        this.vehicle.vehicle_type =  "("+this.vehicle.vehicle_type.vehicle_brands.vehicle_brand_name+") "+' '+ this.vehicle.vehicle_type.vehicle_model+' '+ this.vehicle.vehicle_type.vehicle_year_model
        }
      }
      else if(this.service_estimate.service_estimate_type == 2){
        this.vehicle.id = data.id
        this.vehicle_external_address = data.vehicle_external_address,
        this.vehicle_external_email = data.vehicle_external_email,
        this.vehicle_external_phone = data.vehicle_external_phone,
        this.vehicle_external_name = data.vehicle_external_name,
        this.vehicle.vehicle_production_year = data.vehicle_external_production_year
        this.vehicle_production_year = data.vehicle_external_production_year
        this.vehicle.vehicle_plate_no = data.vehicle_external_plate_no
        this.vehicle_plate_no = data.vehicle_external_plate_no
        this.vehicle.vehicle_registration_name = data.vehicle_external_registration_name
        this.vehicle_registration_name = data.vehicle_external_registration_name
        this.vehicle.vehicle_engine_no = data.vehicle_external_engine_no
        this.vehicle_engine_no = data.vehicle_external_engine_no
        this.vehicle.vehicle_body_color = data.vehicle_external_body_color
        this.vehicle_body_color = data.vehicle_external_body_color
        this.vehicle.vehicle_chassis_no = data.vehicle_external_chassis_no
        this.vehicle_chassis_no = data.vehicle_external_chassis_no
        if(data.vehicle_external_type){
        this.vehicle.vehicle_type =  "("+data.vehicle_external_type.vehicle_brands.vehicle_brand_name+") "+' '+ data.vehicle_external_type.vehicle_model+' '+ data.vehicle_external_type.vehicle_year_model
        this.vehicle_type =  "("+data.vehicle_external_type.vehicle_brands.vehicle_brand_name+") "+' '+ data.vehicle_external_type.vehicle_model+' '+ data.vehicle_external_type.vehicle_year_model
        }
      }
      
      
      
      this.dataValid = true
    },

    async findVehicleDoorNo(){
      var query = {}
      query.filter = {find_vehicle_door_no:this.vehicle.vehicle_door_no}
       await this.$store.dispatch("fms_vehicle/list",query);
       var data = await this.$store.getters["fms_vehicle/list"];
       if(Object.keys(data).length!=0){
           this.setData(data[0])
       }
       else{
         this.swalFindError()
         this.dataValid = false
         var km = null
         if(this.vehicle.vehicle_km){
             km = this.vehicle.vehicle_km
          }
          this.vehicle = []
          this.vehicle.vehicle_km = km
       }
    },
    async findVehiclePlatNo(){
      var query = {}
      if(this.service_estimate.service_estimate_type == 2){
      query.filter = {find_vehicle_external_plate_no:this.vehicle.vehicle_plate_no}
       await this.$store.dispatch("workshop_vehicle_eksternal/list",query);
       console.log('external');
       var data = await this.$store.getters["workshop_vehicle_eksternal/list"];
      }
      else{
      query.filter = {find_vehicle_plate_no:this.vehicle.vehicle_plate_no}
        await this.$store.dispatch("fms_vehicle/list",query);
        console.log('internal');
        var data = await this.$store.getters["fms_vehicle/list"];
      }
      
      if(Object.keys(data).length!=0){
           this.setData(data[0])
      }
      else{
        if(this.service_estimate.service_estimate_type == 2){
          this.swalFindErrorExternal()
          this.dataValid = false
            var km = null
          if(this.vehicle.vehicle_km){
              km = this.vehicle.vehicle_km
          }
          this.vehicle = []
          this.vehicle_external_name = null
          this.vehicle_external_email = null
          this.vehicle_external_phone = null
          this.vehicle_external_address = null
          this.vehicle.vehicle_km = km
        }
        else{
          this.swalFindError()
          this.dataValid = false
            var km = null
          if(this.vehicle.vehicle_km){
              km = this.vehicle.vehicle_km
          }
          this.vehicle = []
          this.vehicle.vehicle_km = km
        }
      }
    },

    swalFindError(){
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
        })
    },

    swalFindErrorExternal(){
      Swal.fire({
          icon: 'error',
          title: 'Not Found',
          text: 'Data kendaraan tidak ditemukan',
          showCancelButton: true,
          cancelButtonText: 'Close',
          confirmButtonText: 'Add New  Vehicle External ?'
        }).then((result) => {
          if (result.value) {
            this.$refs.modalAddVehicleExternalPage.openModal({mode:"se",clickCloseBackground:false});
          }
        })
    },
    

    modalCloseAddVehicleExternal(plat_no){
      this.$refs.modalAddVehicleExternalPage.closeModal();
      if(plat_no){
        this.vehicle.vehicle_plate_no = plat_no;
        this.findVehiclePlatNo();
      }
      
      
    },
    modalCloseList(data){
      console.log(data)
      if(data.id){
        this.setData(data)
      

      this.$refs.modalList.closeModal()
      }
    },

    CloseListVehicleType(){
      this.$refs.modalList.closeModal();
    },

    //fungsi yang di panggil dari sisi parent untuk mengecheck validasi form di page child ini
    async validateForm() {
      const vehicle_plate_no = this.$refs['vehicle_plate_no'];
      const vehicle_km = this.$refs['vehicle_km'];
    let result = []
    if(this.dataValid==false){
      result.push(false)
      this.vehicle.vehicle_plate_no = null
    }
    result.push(
          await vehicle_plate_no.validate().then(function(data){
          return data.valid
          }),
          await vehicle_km.validate().then(function(data){
          return data.valid
          })
      )
      
      return result.every(Boolean)
    }
  },
};
</script>

<style lang="scss" scoped>

.coba{
  width:800px !important;
  height: 780px !important;
  margin: 50px auto !important;
  // margin-bottom: 50mm !important;
  margin-top: 0mm !important;
  // z-index: 9999 !important;
  
  @media screen and (max-width: 992px) {
  // z-index: 9999 !important;
      width: 90% !important;
  margin-top: 0mm !important;

    }
}
</style>
